import axios from 'axios';
import { baseUrl } from '../config';
import buildInfo from '../config/buildInfo.json';

export function getResource(url, versioning = true) {
  return new Promise((resolve, reject) => {
    let resourceUrl = `${baseUrl}/resources/${url}`;
    if (versioning) resourceUrl += `?ver=${buildInfo.build}`;
    axios({
      url: resourceUrl,
      method: 'GET',
      responseType: 'text',
    }).then(response => {
      const data = response.data;
      if (!data) reject('no data');
      if (typeof data === 'string' && data.indexOf('<!doctype') !== -1) reject('404 Not found');
      resolve(data);
    }).catch(e => {
      reject(e);
    })
  })
}

export function getPublic(url) {
  return new Promise((resolve, reject) => {
    axios({
      url: `${baseUrl}/${url}`,
      method: 'GET',
      responseType: 'text',
    }).then(response => {
      const data = response.data;
      if (!data) reject('no data');
      if (typeof data === 'string' && data.indexOf('<!doctype') !== -1) reject('404 Not found');
      resolve(data);
    }).catch(e => {
      reject(e);
    })
  })
}

export function getBuildNo() {
  return new Promise((resolve, reject) => {
    getPublic(`buildInfo.json?v=${getTime()}`)
      .then((response) => {
        resolve(response.build);
      }).catch(e => {
        reject(e)
      });
  });
}

const getTime = () => Math.floor(new Date().getTime());